import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import { CalendarState } from '../../controller';
import { CalendarStatus } from '../../ViewModel/widgetViewModel/widgetViewModel';

export type ResetCalendarStatus = () => void;

export function createResetCalendarStatusAction({
  getControllerState,
}: ActionFactoryParams<CalendarState, CalendarContext>): ResetCalendarStatus {
  return () => {
    const [, setState] = getControllerState();
    setState({
      calendarStatus: CalendarStatus.IDLE,
    });
  };
}
